import { ComponentBase } from '../../../component-base';
import { IMouseDown, IDoubleClick } from '../Interfaces';
import { Injectable } from '@angular/core';
import { DrawingsHolderService } from '../drawings-holder.service';
import { PositionCalculatorService } from '../position-calculator.service';
import { common } from '../common';
import { Edge, IPost, Post, DoublePost, SingleCornerPost } from '../object3D';
import { PostFactoryService } from '../post-factory.service';
import { ObbBuilder } from '../../collision/obb-builder.service';
import { SelectComponent } from '.';
import { DataForDisplayingMenuItemsService } from '../../data-for-displaying-menu-items.service';

declare let THREE: any;

@Injectable()
export class AddCornerPostComponent extends ComponentBase implements IMouseDown, IDoubleClick {
  dblclick(e: MouseEvent): boolean {
    this.selectComponent.enable();
    this.selectComponent.mouseUp(e);
    this.disable();
    return true;
  }
  public scaleCor;

  private raycaster = new THREE.Raycaster(new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, -1, 0));

  constructor(
    private drawings: DrawingsHolderService,
    private positionCalculator: PositionCalculatorService,
    private postFactory: PostFactoryService,
    private selectComponent: SelectComponent,
    private state: DataForDisplayingMenuItemsService
  ) {
    super();
    this.scaleCor = 1;
  }

  mouseDown(e: MouseEvent): boolean {
    const point = this.positionCalculator.calculate(e).setY(common.raycastAtY);

    const isSingleCorner = this.state.currentChoises.cornerPosts === 'Single';

    let post;

    const setPost = () => {
      post.scaleCor = this.scaleCor;
      post.update();
      post.position.copy(point).setY(0);
      this.drawings.canvas.add(post);
    };

    if (isSingleCorner) {
      post = new SingleCornerPost({ postType: 'SC', labelPosition: 'Center' });
      post.modifiedAtStep3 = true;
      setPost();
    } else {
      new THREE.ImageLoader().load('assets/images/scene-plan/c.png', picture => {
        post = new DoublePost(picture);
        post.modifiedAtStep3 = true;
        setPost();
      });
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/AddCornerPostComponent.ts